let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6zPtE")).then(() => parcelRequire('iAqDU'));